import { render, staticRenderFns } from "./OrganizationPeerGroupProfile.vue?vue&type=template&id=46047990&scoped=true&"
import script from "./OrganizationPeerGroupProfile.vue?vue&type=script&lang=ts&"
export * from "./OrganizationPeerGroupProfile.vue?vue&type=script&lang=ts&"
import style0 from "./OrganizationPeerGroupProfile.vue?vue&type=style&index=0&id=46047990&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46047990",
  null
  
)

export default component.exports